import { SingleProduct } from "src/types/graphql.d";
import { LineItem } from "src/types/ctgraphql.d";
import { isNativeApp } from "src/utils/isNativeApp";

let gtmConsentInitialized = false;
const eventQueue: Record<string, unknown>[] = [];

export function initializeGTMConsent(): void {
  if (gtmConsentInitialized) return;

  gtmConsentInitialized = true;

  eventQueue.forEach((data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  });
  eventQueue.length = 0;
}

export function isGTMConsentInitialized(): boolean {
  return gtmConsentInitialized;
}

export function pushToDataLayer(data: Record<string, unknown>): void {
  if (isNativeApp) return;

  if (!gtmConsentInitialized) {
    eventQueue.push(data);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export enum UserType {
  INTERNAL = "internal",
  EXTERNAL = "external",
}

function getUserType(email: string, domain = "otrium.com") {
  return email.includes(domain) ? UserType.INTERNAL : UserType.EXTERNAL;
}

export const googleTagManager = {
  trackAlreadyRegistered: (): void => {
    pushToDataLayer({ event: "already_registered" });
  },

  trackUser: (userId?: string, userEmail?: string): void => {
    pushToDataLayer({
      event: "user data updated",
      user_id: userId,
      user_email: userEmail,
      user_type: userEmail ? getUserType(userEmail) : undefined,
    });
    pushToDataLayer({
      event: "user_id_in_data_layer",
    });
  },

  trackHomePage: (email: string): void => {
    pushToDataLayer({
      event: "crto_homepage",
      crto: {
        email,
      },
    });
  },

  trackProductPage: (email: string, product: SingleProduct): void => {
    pushToDataLayer({
      event: "crto_productpage",
      crto: {
        email,
        products: [product.id],
        price: product.price,
        quantity: 1,
      },
    });
  },

  trackCartPage: (email: string, products?: LineItem[] | null): void => {
    pushToDataLayer({
      event: "crto_basketpage",
      crto: {
        email,
        products: (products || []).map((product) => ({
          id: product.id,
          price: product.price.value.centAmount,
          quantity: product.quantity,
        })),
      },
    });
  },

  trackSearchNoResults: (query: string): void => {
    pushToDataLayer({
      event: "search_no_result",
      search_query_no_result: query,
    });
  },
};
